import React from 'react'

/** Minimum investment row — shield + check (Figma asset). */
export const InvestV2HintShieldIcon = ({ className = '' }: { className?: string }) => (
  <svg
    className={className}
    xmlns='http://www.w3.org/2000/svg'
    width='12'
    height='15'
    viewBox='0 0 12 15'
    fill='none'
    aria-hidden
  >
    <path
      d='M5.2125 10.1625L9.45 5.925L8.38125 4.85625L5.2125 8.025L3.6375 6.45L2.56875 7.51875L5.2125 10.1625ZM6 15C4.2625 14.5625 2.82812 13.5656 1.69687 12.0094C0.565625 10.4531 0 8.725 0 6.825V2.25L6 0L12 2.25V6.825C12 8.725 11.4344 10.4531 10.3031 12.0094C9.17188 13.5656 7.7375 14.5625 6 15ZM6 13.425C7.3 13.0125 8.375 12.1875 9.225 10.95C10.075 9.7125 10.5 8.3375 10.5 6.825V3.28125L6 1.59375L1.5 3.28125V6.825C1.5 8.3375 1.925 9.7125 2.775 10.95C3.625 12.1875 4.7 13.0125 6 13.425Z'
      fill='#666666'
    />
  </svg>
)

/** Support strip — headset mark in circular badge (tan line on white). */
export const InvestV2SupportHeadsetIcon = () => (
  <svg
    width='26'
    height='26'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden
  >
    <path
      d='M5 14.5v2a2 2 0 002 2h1M19 14.5v2a2 2 0 01-2 2h-1M8 18.5h-.5A2.5 2.5 0 016 16v-2a6 6 0 1112 0v2a2.5 2.5 0 01-2.5 2.5H15'
      stroke='#b8956a'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
    <path d='M14 18.5v1a2 2 0 01-2 2h-1' stroke='#b8956a' strokeWidth='1.5' strokeLinecap='round' />
  </svg>
)
